// extracted by mini-css-extract-plugin
export default {"disc":"_1yu-9"};